<template>
<div class="content">
  平台协议
</div>
</template>

<script>
export default {
  name: "agreement"
}
</script>

<style lang="scss" scoped>
.content{
  padding: 30px;text-align: left;
}
</style>
